import { render, staticRenderFns } from "./InventorySnapShots.vue?vue&type=template&id=13cb4e72"
import script from "./InventorySnapShots.vue?vue&type=script&lang=js"
export * from "./InventorySnapShots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports